const videoPlayer = document.querySelector("#review-article-video-player");
const playBtn = document.querySelector("#review-article-video-play-btn");
const videoLabel = document.querySelector("#review-article-video-label");
const videoCover = document.querySelector("#review-article-video-cover");

playBtn.addEventListener("click", (e) => {
  e.preventDefault();

  if (videoPlayer.paused) {
    videoPlayer.play();
    videoPlayer.setAttribute("controls", "controls");
    playBtn.classList.add("hide-play-btn");
    videoLabel.classList.add("hide-label");
    videoCover.classList.add("hide-overlay");
  } else {
    videoPlayer.pause();
    videoPlayer.removeAttribute("controls");
    playBtn.classList.remove("hide-play-btn");
    videoLabel.classList.remove("hide-label");
    videoCover.classList.remove("hide-overlay");
  }
});

videoPlayer.addEventListener("ended", () => {
  videoPlayer.removeAttribute("controls");
  playBtn.classList.remove("hide-play-btn");
  videoLabel.classList.remove("hide-label");
  videoCover.classList.remove("hide-overlay");
  videoPlayer.currentTime = 0;
  videoPlayer.load();
});
